const defaultState = {
  loading: true
}

const app = (state = defaultState, action) => {
  switch (action.type) {
    case 'APP_DATA_LOADED':
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export default app



// WEBPACK FOOTER //
// ./src/reducers/app.js